(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ar-cutoff-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ar-cutoff-banner')) {
  customElements.define('ar-cutoff-banner', class extends HTMLElement {
    connectedCallback() {
      this.formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.refreshHandler = () => { clearTimeout(this.debounce); this.debounce = setTimeout(() => this.refreshCart(), 150); };
      window.addEventListener('cartcount:update', this.refreshHandler, options);
      window.addEventListener('pageshow', event => { if (event.persisted) this.refreshHandler(); }, options);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.refreshHandler(); }, options);
      if ('PerformanceObserver' in window) {
        this.observer = new PerformanceObserver(list => {
          if (list.getEntries().some(entry => {
            const url = new URL(entry.name, location.href);
            return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
          })) this.refreshHandler();
        });
        this.observer.observe({ type: 'resource', buffered: false });
      }
      document.addEventListener('variant-change', () => this.update(), { ...options, capture: true });
      this.update();
      this.interval = setInterval(() => { if (!document.hidden) this.update(); }, 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); clearTimeout(this.debounce); this.abort?.abort(); this.observer?.disconnect(); }
    async refreshCart() {
      const version = this.refreshVersion = (this.refreshVersion || 0) + 1;
      try {
        const url = new URL(this.dataset.root, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('_ar_shipping', Date.now());
        const response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.querySelector('ar-cutoff-banner');
        if (updated && version === this.refreshVersion && this.isConnected) {
          this.dataset.cartLive = updated.dataset.cartLive;
          this.update();
        }
      } catch (_) {}
    }
    holidayDates(year) {
      const a = year % 19, b = Math.floor(year / 100), c = year % 100;
      const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const n = h + l - 7 * m + 114;
      const easter = Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1);
      const dates = ['01-01', '01-06', '03-08', '05-01', '08-08', '08-15', '09-20', '10-03', '10-31', '11-01', '12-25', '12-26'].map(value => `${year}-${value}`);
      for (const offset of [-2, 0, 1, 39, 49, 50, 60]) dates.push(new Date(easter + offset * 86400000).toISOString().slice(0, 10));
      const november23 = Date.UTC(year, 10, 23);
      const back = (new Date(november23).getUTCDay() - 3 + 7) % 7 || 7;
      dates.push(new Date(november23 - back * 86400000).toISOString().slice(0, 10));
      return dates;
    }
    holidayCalendar(year) {
      const extra = this.dataset.extraHolidays || '';
      const key = `${year}:${extra}`;
      this.calendarCache ||= new Map();
      if (!this.calendarCache.has(key)) {
        const dates = new Set([year - 1, year, year + 1].flatMap(value => this.holidayDates(value)));
        for (const value of extra.split(/[\s,;]+/)) {
          if (/^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value)) && new Date(value).toISOString().slice(0, 10) === value) dates.add(value);
        }
        this.calendarCache.set(key, dates);
      }
      return this.calendarCache.get(key);
    }
    holidayShippingExclusions(year) {
      if (this.dataset.holidayPause !== 'true') return [];
      const dates = this.holidayCalendar(year);
      const excluded = new Set();
      for (const value of dates) {
        const date = new Date(`${value}T00:00:00Z`);
        const weekday = date.getUTCDay();
        if (weekday === 0 || weekday === 6) continue;
        excluded.add(value);
        if (weekday === 1 || weekday === 5) {
          const offset = weekday === 1 ? 1 : 3;
          excluded.add(new Date(date.getTime() + offset * 86400000).toISOString().slice(0, 10));
        }
      }
      return [...excluded];
    }
    holidayBlocked(utc, seconds, days, cutoff, excluded) {
      if (this.dataset.holidayPause !== 'true') return false;
      const year = new Date(utc).getUTCFullYear();
      const extra = this.dataset.extraHolidays || '';
      const key = JSON.stringify([year, days, cutoff, excluded, extra]);
      this.holidayCache ||= new Map();
      if (!this.holidayCache.has(key)) {
        const dates = this.holidayCalendar(year);
        const weeks = new Set([...dates].filter(value => {
          const weekday = new Date(`${value}T00:00:00Z`).getUTCDay();
          return weekday >= 2 && weekday <= 4;
        }).map(value => {
          const date = new Date(`${value}T00:00:00Z`);
          return date.getTime() - (date.getUTCDay() + 6) % 7 * 86400000;
        }));
        const windows = [...weeks].map(monday => {
          let start = monday - 7 * 86400000;
          for (let back = 1; back <= 7; back++) {
            const day = new Date(monday - back * 86400000);
            const date = day.toISOString().slice(0, 10);
            if (days.includes(day.getUTCDay()) && !excluded.includes(date) && !dates.has(date)) {
              start = day.getTime() + cutoff * 1000;
              break;
            }
          }
          return { start, end: monday + 8 * 86400000 };
        });
        this.holidayCache.set(key, windows);
      }
      const localNow = utc + seconds * 1000;
      return this.holidayCache.get(key).some(window => localNow >= window.start && localNow < window.end);
    }
    state(live, now = new Date()) {
      const parts = Object.fromEntries(this.formatter.formatToParts(now).map(part => [part.type, part.value]));
      const date = `${parts.year}-${parts.month}-${parts.day}`;
      const utc = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
      const weekday = new Date(utc).getUTCDay();
      const seconds = Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second);
      const parseTime = value => { const m = /^(\d{1,2}):(\d{2})$/.exec(value.trim()); return m && +m[1] < 24 && +m[2] < 60 ? +m[1] * 3600 + +m[2] * 60 : null; };
      const cutoffText = live ? this.dataset.liveCutoff : this.dataset.cutoff;
      const cutoff = parseTime(cutoffText), start = parseTime(this.dataset.start);
      const valid = cutoff !== null && start !== null && start < cutoff;
      const rest = Math.max(0, cutoff - seconds), pad = n => String(n).padStart(2, '0');
      const clock = `${pad(Math.floor(rest / 3600))}:${pad(Math.floor(rest % 3600 / 60))}:${pad(rest % 60)}`;
      const finish = value => ({ ...value, clock,
        message: (value.before ? this.dataset.beforeText : this.dataset.afterText).replaceAll('{uhrzeit}', cutoffText).replaceAll('{countdown}', clock),
        nextRemaining: value.nextDeadline === null ? null : Math.max(0, Math.ceil((value.nextDeadline - now.getTime()) / 1000))
      });
      const cacheKey = JSON.stringify([date, live, cutoffText, this.dataset.start, this.dataset.days, this.dataset.accessoryDays, this.dataset.excluded, this.dataset.holidayPause, this.dataset.extraHolidays, this.dataset.after, document.documentElement.lang, seconds >= start, seconds >= cutoff]);
      this.stateCache ||= new Map();
      if (this.stateCache.has(cacheKey)) return finish(this.stateCache.get(cacheKey));
      const days = (live ? this.dataset.days : this.dataset.accessoryDays).split(',').filter(Boolean).map(Number);
      const excluded = [...this.dataset.excluded.split(/[\s,;]+/), ...this.holidayShippingExclusions(Number(parts.year))];
      const allowed = days.includes(weekday) && !excluded.includes(date);
      const before = valid && allowed && seconds >= start && seconds < cutoff;
      const after = valid && (!allowed || seconds >= cutoff) && this.dataset.after === 'text';
      let next = '', nextDeadline = null;
      for (let offset = allowed && seconds < cutoff ? 0 : 1; valid && days.length && offset < 370; offset++) {
        const candidate = new Date(utc + offset * 86400000);
        if (days.includes(candidate.getUTCDay()) && !excluded.includes(candidate.toISOString().slice(0, 10))) {
          const locale = document.documentElement.lang || 'de';
          if (this.dateLocale !== locale) {
            this.dateLocale = locale;
            this.dateFormatter = new Intl.DateTimeFormat(locale, { timeZone: 'UTC', weekday: 'long', day: '2-digit', month: '2-digit' });
          }
          next = this.dateFormatter.format(candidate);
          const wallTime = candidate.getTime() + cutoff * 1000;
          nextDeadline = wallTime;
          for (let pass = 0; pass < 3; pass++) {
            const p = Object.fromEntries(this.formatter.formatToParts(new Date(nextDeadline)).map(part => [part.type, part.value]));
            const displayed = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
            nextDeadline += wallTime - displayed;
          }
          break;
        }
      }
      const holidayBlocked = valid && this.holidayBlocked(utc, seconds, days, cutoff, excluded);
      const result = { before, after, valid, next, nextDeadline, holidayBlocked };
      if (this.stateCache.size >= 8) this.stateCache.clear();
      this.stateCache.set(cacheKey, result);
      return finish(result);
    }
    update() {
      const cartLive = this.dataset.cartLive === 'true';
      const state = this.state(cartLive);
      const editor = this.dataset.editor === 'true' && !state.before && !state.after;
      this.hidden = state.holidayBlocked || this.dataset.enabled !== 'true' || (!state.before && !state.after && !editor);
      const message = state.next ? this.dataset.next.replace('{datum}', state.next) : state.message;
      const el = this.querySelector('[data-message]');
      if (el.textContent !== message) el.textContent = message;
      const desktopMessage = this.querySelector('[data-desktop-message]');
      if (desktopMessage) {
        const text = this.dataset.desktopText.replace('{datum}', state.next);
        if (desktopMessage.textContent !== text) desktopMessage.textContent = text;
      }
      const timer = this.querySelector('[data-timer]');
      if (timer) {
        timer.hidden = state.nextRemaining === null;
        if (state.nextRemaining !== null) {
          const rest = state.nextRemaining;
          const day = Math.floor(rest / 86400);
          const parts = [day ? `${day} ${this.dataset.unitDay}` : '', `${Math.floor(rest % 86400 / 3600)} ${this.dataset.unitHour}`, `${Math.floor(rest % 3600 / 60)} ${this.dataset.unitMinute}`, `${rest % 60} ${this.dataset.unitSecond}`];
          this.querySelector('[data-clock]').textContent = parts.filter(Boolean).join(' ');
        }
      }
      const preview = this.querySelector('[data-preview]'); if (preview) preview.hidden = !editor;
      document.querySelectorAll('[data-ar-product-shipping]').forEach(hint => {
        const variantId = hint.closest('[data-product-wrapper]')?.querySelector('variant-selection')?.getAttribute('variant');
        const availableIds = hint.dataset.availableVariants.split(',');
        const available = variantId ? availableIds.includes(variantId) : hint.dataset.available === 'true';
        const live = cartLive || hint.dataset.productLive === 'true';
        const result = this.state(live);
        hint.hidden = result.holidayBlocked || this.dataset.productHint !== 'true' || !available || !result.valid;
        const text = result.next ? this.dataset.next.replace('{datum}', result.next) : result.message;
        const label = hint.querySelector('[data-shipping-message]');
        if (label.textContent !== text) label.textContent = text;
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ar-v1-navigation"]) return;
  try {
    
(() => {
  function init() {
    const root = document.querySelector('[data-arv1-navigation]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const nav = root.querySelector('.arv1-nav');
    const items = [...nav.querySelectorAll('.arv1-nav__item')].filter(item => item.querySelector('.arv1-mega'));
    nav.classList.remove('arv1-nav--hover');
    let current, switchTimer, closeTimer;
    const setOpen = item => {
      if (current === item) return;
      if (current) { current.classList.remove('is-open'); current.querySelector('.arv1-nav__link').setAttribute('aria-expanded','false'); current.dispatchEvent(new Event('arv1-close')); }
      current = item;
      if (item) { item.classList.add('is-open'); item.querySelector('.arv1-nav__link').setAttribute('aria-expanded','true'); item.dispatchEvent(new Event('arv1-open')); }
    };
    items.forEach((item, index) => {
      const link=item.querySelector('.arv1-nav__link'), panel=item.querySelector('.arv1-mega');
      panel.id='arv1-mega-'+index;
      link.setAttribute('aria-controls',panel.id); link.setAttribute('aria-expanded','false');
      item.addEventListener('mouseenter',()=>{clearTimeout(closeTimer);clearTimeout(switchTimer);if(!current)setOpen(item);else switchTimer=setTimeout(()=>setOpen(item),220);});
      item.addEventListener('mouseleave',()=>{clearTimeout(switchTimer);closeTimer=setTimeout(()=>setOpen(null),180);});
      item.addEventListener('focusin',()=>{clearTimeout(closeTimer);setOpen(item);});
      item.addEventListener('focusout',e=>{if(!item.contains(e.relatedTarget))closeTimer=setTimeout(()=>setOpen(null),180);});
      link.addEventListener('click',e=>{if(!matchMedia('(hover:hover)').matches&&current!==item){e.preventDefault();setOpen(item);}});
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&current){const link=current.querySelector('.arv1-nav__link');link.focus();setOpen(null);link.blur();}});
    root.querySelectorAll('[data-arv1-promo-carousel]').forEach(box=>{
      const slides=[...box.querySelectorAll('.arv1-mega__slide')], item=box.closest('.arv1-nav__item');
      if(!slides.length||!item)return;
      let index=0,timer,paused=false;
      const load=slide=>{const img=slide.querySelector('img[data-src]');if(img){img.src=img.dataset.src;img.removeAttribute('data-src');}const bg=slide.querySelector('[data-bg]');if(bg){bg.style.backgroundImage='url("'+bg.dataset.bg+'")';bg.removeAttribute('data-bg');}};
      const stop=()=>{clearInterval(timer);timer=null;};
      item.addEventListener('arv1-open',()=>{load(slides[index]);stop();if(slides.length>1&&!matchMedia('(prefers-reduced-motion:reduce)').matches)timer=setInterval(()=>{if(paused||box.contains(document.activeElement))return;slides[index].classList.remove('is-active');index=(index+1)%slides.length;load(slides[index]);slides[index].classList.add('is-active');},Number(box.dataset.interval)||3000);});
      item.addEventListener('arv1-close',stop);
      box.addEventListener('mouseenter',()=>{paused=true;});box.addEventListener('mouseleave',()=>{paused=false;});
    });
    const drawer=root.querySelector('[data-arv1-drawer]');
    if(!drawer)return;
    const existing=document.getElementById('arv1-mobile-drawer');
    if(existing&&existing!==drawer)existing.remove();
    document.body.appendChild(drawer);
    let lastFocus,scrollY=0,bodyStyle='',timer;
    const buttons=()=>[...document.querySelectorAll('[data-arv1-burger]')];
    const close=()=>{
      if(drawer.hidden)return;
      drawer.classList.remove('is-open');buttons().forEach(b=>b.setAttribute('aria-expanded','false'));
      document.body.style.cssText=bodyStyle;window.scrollTo(0,scrollY);
      timer=setTimeout(()=>{drawer.hidden=true;},220);
      if(lastFocus&&lastFocus.isConnected)lastFocus.focus();
    };
    const open=()=>{
      clearTimeout(timer);lastFocus=document.activeElement;scrollY=window.scrollY;bodyStyle=document.body.style.cssText;
      drawer.hidden=false;void drawer.offsetWidth;drawer.classList.add('is-open');
      buttons().forEach(b=>b.setAttribute('aria-expanded','true'));
      Object.assign(document.body.style,{position:'fixed',top:-scrollY+'px',left:'0',right:'0',width:'100%',overflow:'hidden'});
      drawer.querySelector('[data-arv1-drawer-close] button, button[data-arv1-drawer-close]').focus();
    };
    // Capture only our burger, before Empire's delegated menu handler.
    document.addEventListener('click',e=>{
      const burger=e.target.closest('[data-arv1-burger]');if(!burger)return;
      e.preventDefault();e.stopImmediatePropagation();if(drawer.classList.contains('is-open'))close();else open();
    },true);
    drawer.querySelectorAll('[data-arv1-drawer-close]').forEach(el=>el.addEventListener('click',close));
    drawer.addEventListener('click',e=>{if(e.target.closest('a[href]'))close();});
    const details=[...drawer.querySelectorAll('.arv1-drawer__list details')];
    details.forEach(item=>item.addEventListener('toggle',()=>{if(item.open)details.forEach(other=>{if(other!==item&&other.parentElement.closest('details')===item.parentElement.closest('details'))other.open=false;});}));
    document.addEventListener('keydown',e=>{
      if(!drawer.classList.contains('is-open'))return;
      if(e.key==='Escape'){e.preventDefault();close();return;}
      if(e.key!=='Tab')return;
      const focusable=[...drawer.querySelectorAll('a[href],button:not([disabled]),input,summary,[tabindex="0"]')].filter(el=>el.getClientRects().length);
      const first=focusable[0],last=focusable[focusable.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });
    matchMedia('(min-width:1024px)').addEventListener('change',e=>{if(e.matches&&drawer.classList.contains('is-open'))close();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();
})();
